import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-service1",
  "use": "icon-service1-usage",
  "viewBox": "0 0 6 4",
  "content": "<symbol viewBox=\"0 0 6 4\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-service1\">\n<path d=\"M4.1818 0.0458077L1.45453 0.225562C0.545428 0.225562 0 0.764746 0 1.30397L0.181797 3.10131C0.181797 3.64053 0.909062 4 1.81816 4L4.54543 3.82025C5.45453 3.82025 6 3.28106 6 2.74184L5.81817 0.944498C5.63637 0.225562 4.90903 -0.133946 4.1818 0.0458077Z\" fill=\"#206FED\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol